import { render } from "./PurchaseInvoiceModal.vue?vue&type=template&id=3d51015c&scoped=true"
import script from "./PurchaseInvoiceModal.vue?vue&type=script&lang=js"
export * from "./PurchaseInvoiceModal.vue?vue&type=script&lang=js"

import "./PurchaseInvoiceModal.vue?vue&type=style&index=0&id=3d51015c&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d51015c"]])

export default __exports__